import React from "react";
import "./App.css";
import { BrowserRouter as Router, Switch, Route, Redirect } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import Login from "./Components/Login";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap";
import "react-toastify/dist/ReactToastify.css";
import ViewerDashboard from "./Components/ViewerDashboard";
import Header from "./Components/Header";
import UserManagment from "./Components/UserManagment";
import SignUp from "./Components/SignUp";
import ExpiredLink from "./Components/ExpiredLink";
import ProtectRoute from "./Components/ProtectedRoute";
import Spinner from "./Components/Spinner";
import ForgetPassword from './Components/ForgetPassword';
import ResetPassword from './Components/ResetPassword';

const App:React.FC = () => {

    return (
      <div id="parent-div">
        <ToastContainer />
        <Spinner />
        <Router basename="/#">
          <Header />
          <div id="content-div">
            <Switch>
              <Route exact path="/login" component={Login} />
              <Route exact path='/signup' render={(props) => <SignUp {...props} />} />
              <Route exact path='/error' component={ExpiredLink}/>
              <Route exact path='/forgot_password' render={(props) => <ForgetPassword {...props} />} />
              <Route exact path='/reset_password' render={(props) => <ResetPassword {...props} />} />
              <ProtectRoute exact path='/viewer_dashboard' component={ViewerDashboard} />
              <ProtectRoute exact path='/user_managment' component={UserManagment} />
              <Redirect from="*" to="/viewer_dashboard" />
            </Switch>
          </div>
        </Router>
      </div>
    );
}

export default App;
